/**
 * Wrapper pour jwt-decode qui gère les différences entre ESM et CJS
 * jwt-decode v4 est ESM-only et peut avoir des problèmes avec Turbopack
 */

// Import namespace pour gérer à la fois ESM et CJS
import * as jwtDecodeModule from "jwt-decode";

// Type pour gérer les différentes formes d'export de jwt-decode
type JwtDecodeFunction = (token: string) => unknown;

// Type pour le module jwt-decode avec toutes ses formes possibles
// Peut être une fonction directement, ou un objet avec default/jwtDecode
type JwtDecodeModuleType = JwtDecodeFunction | { default?: JwtDecodeFunction; jwtDecode?: JwtDecodeFunction } | Record<string, unknown>;

// Extraire la fonction de décodage
// En ESM pur, jwt-decode exporte une fonction par défaut
// En CJS, elle peut être dans default ou directement accessible
// Type assertion pour gérer les différences entre ESM et CJS
const jwtDecodeModuleAny = jwtDecodeModule as unknown as JwtDecodeModuleType;

// Vérification à l'exécution pour déterminer comment accéder à la fonction
// Utilisation de if/else explicites pour une meilleure inférence de type
let jwtDecodeFunction: JwtDecodeFunction;

if (typeof jwtDecodeModuleAny === "function") {
	jwtDecodeFunction = jwtDecodeModuleAny as JwtDecodeFunction;
} else {
	const moduleObj = jwtDecodeModuleAny as Record<string, unknown>;
	const defaultExport = moduleObj["default"];
	const namedExport = moduleObj["jwtDecode"];
	if (typeof defaultExport === "function") {
		jwtDecodeFunction = defaultExport as JwtDecodeFunction;
	} else if (typeof namedExport === "function") {
		jwtDecodeFunction = namedExport as JwtDecodeFunction;
	} else {
		// Fallback: essayer d'utiliser le module directement
		jwtDecodeFunction = jwtDecodeModuleAny as JwtDecodeFunction;
	}
}

export const jwtDecode = jwtDecodeFunction as <T = unknown>(token: string) => T;
